<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">FIDEICOMISOS (HASTA LOS ÚLTIMOS 2 AÑOS) </legend>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label class="control-label"> ¿ Tiene fideicomisos ? <b-button class="btn-popover" v-b-popover.hover.top="info.fideicomisos"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de la participación en fideicomisos de la pareja o dependientes económicos no serán públicos. </div>
        </div>
        <div class="row">
          <legend>Datos del fideicomiso</legend>
          <div class="col-md-12 form-group">
            <label class="control-label">Participación en fideicomisos <b-button class="btn-popover" v-b-popover.hover.top="info.participante"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="participante" v-validate="'required'" v-model="form_item.participante" label="1" class="d-inline-block">Declarante</p-radio>
            <p-radio name="participante" v-validate="'required'" v-model="form_item.participante" label="2" class="d-inline-block">Pareja</p-radio>
            <p-radio name="participante" v-validate="'required'" v-model="form_item.participante" label="3" class="d-inline-block">Dependiente Económico</p-radio>
            <br><small class="text-danger">{{ errors.first('participante')}}</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="control-label">Tipo de fideicomiso <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_fideicomiso_id"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" name="tipo_fideicomiso" v-validate="'required'" placeholder="Seleccione una opción" v-model="form_item.tipo_fideicomiso_id">
              <el-option v-for="option in tipos_fideicomisos" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo_fideicomiso')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Tipo de participación <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_participacion_id"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" name="tipo_participacion" v-validate="'required'" placeholder="Seleccione una opción" v-model="form_item.tipo_participacion_id">
              <el-option v-for="option in tipos_fideicomisos_part" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo_participacion')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC del fideicomiso <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_fideicomiso"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_fideicomiso" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc_fideicomiso" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_fideicomiso')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Fideicomitente <b-button class="btn-popover" v-b-popover.hover.top="info.fideicomitente"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="fideicomitente" class="d-inline-block" v-validate="'required'" v-model="form_item.fideicomitente" label="1">Persona física</p-radio>
            <p-radio name="fideicomitente" class="d-inline-block" v-validate="'required'" v-model="form_item.fideicomitente" label="2">Persona moral</p-radio>
            <br><small class="text-danger">{{ errors.first('fideicomitente')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre o razón social del fideicomitente <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_fideicomitente"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_fideicomitente" v-validate="'required'" v-model="form_item.nombre_fideicomitente" placeholder="Nombre o razón social del otorgante ">
            <small class="text-danger">{{ errors.first('nombre_fideicomitente')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_fideicomitente"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_fideicomitente" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc_fideicomitente" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_fideicomitente')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre o razón social del fiduciario <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_fiduciario"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_fiduciario" v-validate="'required'" v-model="form_item.nombre_fiduciario" placeholder="Nombre o razón social del otorgante ">
            <small class="text-danger">{{ errors.first('nombre_fiduciario')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_fiduciario"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_fiduciario" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc_fiduciario" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_fiduciario')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Fideicomisario <b-button class="btn-popover" v-b-popover.hover.top="info.fideicomisario"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="fideicomisario" class="d-inline-block" v-validate="'required'" v-model="form_item.fideicomisario" label="1">Persona física</p-radio>
            <p-radio name="fideicomisario" class="d-inline-block" v-validate="'required'" v-model="form_item.fideicomisario" label="2">Persona moral</p-radio>
            <br><small class="text-danger">{{ errors.first('fideicomisario')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre o razón social del fideicomisario <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_fideicomisario"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_fideicomisario" v-validate="'required'" v-model="form_item.nombre_fideicomisario" placeholder="Nombre o razón social del otorgante ">
            <small class="text-danger">{{ errors.first('nombre_fideicomisario')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_fideicomisario"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_fideicomisario" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc_fideicomisario" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_fideicomisario')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Sector productivo al que pertenece <b-button class="btn-popover" v-b-popover.hover.top="info.sector"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" name="sector" v-validate="'required'" filterable placeholder="Seleccione una opción" v-model="form_item.sector_industria_id">
              <el-option v-for="option in sectores_industria" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('sector') }}</small>
          </div>
          <legend>¿Dónde se localiza el fideicomiso? <b-button class="btn-popover" v-b-popover.hover.top="info.lugar"><i class="far fa-question-circle"></i></b-button>
          </legend>
          <div class="form-group  col-6">
            <label class="control-label"> País </label>
            <el-select  clearable name="pais" v-validate="'required'" class="select-default" filterable placeholder="País" v-model="form_item.pais_id">
              <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('pais') }}</small>
          </div>
          <!-- <div class="form-group col-6" v-if="form_item.pais_id==150">
            <label class="control-label"> Entidad Federativa </label>
            <el-select  clearable class="select-default" name="entidad" v-validate="'required'" filterable placeholder="Entidad" v-model="form_item.entidad_federativa_id">
              <el-option v-for="option in entidades" class="select-default" :value="option.id" :label="option.nom_ent" :key="option.nom_ent">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('entidad') }}</small>
          </div> -->
          <div class="form-group col-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details></v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.participante="{ item }">
                <div>{{filterDeclarante(item.participante)}}</div>
              </template>
              <template v-slot:item.tipo_fideicomiso_id="{ item }">
                <div>{{filterTipofideicomiso(item.tipo_fideicomiso_id)}}</div>
              </template>
              <template v-slot:item.tipo_participacion_id="{ item }">
                <div>{{filterTipoFideicomisoPart(item.tipo_participacion_id)}}</div>
              </template>
              <template v-slot:item.otorgante="{ item }">
                <div>{{filterTipoPersona(item.otorgante)}}</div>
              </template>
              <template v-slot:item.sector_industria_id="{ item }">
                <div>{{filterSector(item.sector_industria_id)}}</div>
              </template>
              <!-- <template v-slot:item.monto="{ item }">
                <div> {{item.monto | currency}}</div>
              </template>
              <template v-slot:item.tipo_moneda="{ item }">
                <div> {{filterTipoMoneda(item.tipo_moneda)}}</div>
              </template> -->
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
    },
    props: ["data"],
    data() {
      return {
        ip_id: 1,
        add_item: false,
        edit_item: null,
        bandera: '0',
        form_item: {},
        table_list: [],
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Participación en fideicomisos',
          value: 'participante',
          align: 'center',
        }, {
          text: 'Tipo de fideicomiso',
          value: 'tipo_fideicomiso_id',
          align: 'center',
        }, {
          text: 'Tipo de participación',
          value: 'tipo_participacion_id',
          align: 'center',
        }, {
          text: 'RFC del fideicomiso',
          value: 'rfc_fideicomiso',
          align: 'center',
        }, {
          text: 'Nombre del fideicomitente',
          value: 'nombre_fideicomitente',
          align: 'center',
        }, {
          text: 'RFC fideicomitente',
          value: 'rfc_fideicomitente',
          align: 'center',
        }, {
          text: 'Nombre del fiduciario',
          value: 'nombre_fiduciario',
          align: 'center',
        }, {
          text: 'RFC fideicomitente',
          value: 'rfc_fideicomitente',
          align: 'center',
        }, {
          text: 'Nombre del fideicomisario',
          value: 'nombre_fideicomisario',
          align: 'center',
        }, {
          text: 'RFC fideicomisario',
          value: 'rfc_fideicomisario',
          align: 'center',
        }, {
          text: 'Sector',
          value: 'sector_industria_id',
          align: 'center',
        }, ],
        info: {
          fideicomisos: 'Este apartado solo lo llenaran las personas servidoras públicas que tengan participación en un fideicomiso, ya sea en el carácter de fideicomitente, fiduciario, fideicomisario o dentro del consejo técnico. Deberá reportar hasta los últimos dos años.',
          participante: 'Elegir quien es el participante en el fideicomiso, el Declarante, Pareja o dependiente económico.',
          tipo_fideicomiso_id: 'Seleccionar si es público, privado o mixto.',
          tipo_participacion_id: 'Seleccionar su participación como fideicomitente, fiduciario, fideicomisario o dentro del Comité Técnico.',
          rfc_fideicomiso: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomiso.',
          fideicomitente: 'Seleccionar si es persona física o persona moral.',
          nombre_fideicomitente: 'Proporcionar nombre completo.',
          rfc_fideicomitente: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomitente.',
          nombre_fiduciario: 'Proporcionar nombre completo.',
          rfc_fiduciario: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fiduciario.',
          fideicomisario: 'Seleccionar si es persona física o persona moral.',
          nombre_fideicomisario: 'Proporcionar nombre completo.',
          rfc_fideicomisario: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomisario.',
          sector: 'Elegir el sector al que pertenece.',
          lugar: 'Seleccionar en México o en el extranjero.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
      };
    },
    computed: {},
    watch: {},
    methods: {

      showItem() {
        this.add_item = true;
        if (!this.form_item.pais_id) {
          //El id Mexico es 150
          this.form_item.pais_id = 150;
        }
        this.$validator.resume();
      },
      cancelEdit() {
        //this.showItem();
        this.add_item = false;
        this.form_item = {};
        this.edit_item = null;
        this.$validator.pause();
      },
      addItem() {
        /* this.validateRfc(this.validaciones, this.form_item).then(response => {
          if (response.every(v => v === true)) { */
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("fideicomisos", this.form_item).then(response => {
                this.StepOk("Guardado");
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();
              }, error => {
                this.StepError(error);
              });
            }
          } else {
            this.StepW("Hay campos sin completar");
            this.$el.querySelector("[aria-invalid=true]").scrollIntoView({
              block: "center",
              behavior: "smooth"
            });
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = item;
        this.form_item = {
          ...this.edit_item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("fideicomisos/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
    },
    created() {
      this.ip_id = this.getKey('uid');
      //this.getLocalidades(97250);
      this.$http.get("fideicomisos/" + this.ip_id).then(response => {
        this.table_list = response.data.response;
        if (this.table_list) {
          if (this.table_list.length > 0) {
            this.bandera = '1';
          }
        }
      }, error => {
        this.Err(error);
      });
      /* this.$http.get("cat_tipo_operacion_inversion").then(response => {
        this.operaciones = response.data.tipos;
      }, error => {
        this.Err(error);
      });
      this.$http.get("cat_tipo_fideicomiso_id").then(response => {
        this.fideicomisos = response.data.tipos;
      }, error => {
        this.Err(error);
      }); */
    },
    mounted() {
      this.checkCatalogs();
      //El id Mexico es 150
      this.form_item.pais_id = 150;
    }
  };

</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Intereses/Fideicomisos.vue